import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Cost center create/update request body - DTO siganture */
export interface CostCenterFormInterface {
  /** Cost center display name */
  name: string;
}

/** Cost center create/update request body - DTO schema */
export const CostCenterFormDto = SerdeDtoClass.create<CostCenterFormInterface>(CatalogDtosKeysEnum.COST_CENTER_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
});
